import React, {
  createContext,
  useCallback,
  useContext,
  useReducer,
} from "react";

import { Delivery } from "../../Models";

import api from "../Api";

export const CONSTANTS = {
  FETCH_BY_ID: "FETCH_BY_ID",
  FETCH_ONE_COMPLETED: "FETCH_ONE_COMPLETED",
  FETCH_RIDER_LOCATION: "FETCH_RIDER_LOCATION",
};

const INITIAL_STATE = {
  item: null,
  riderLocation: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case CONSTANTS.FETCH_BY_ID:
      return {
        ...state,
        item: action.item,
        riderLocation: null,
      };
    case CONSTANTS.FETCH_ONE_COMPLETED:
      return {
        ...state,
        item: action.item,
      };
    case CONSTANTS.FETCH_RIDER_LOCATION:
      return {
        ...state,
        riderLocation: action.riderLocation,
      };
    default:
      return INITIAL_STATE;
  }
};

export const Context = createContext(INITIAL_STATE);

export const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  return (
    <Context.Provider value={{ dispatch, state }}>{children}</Context.Provider>
  );
};

export const useDeliveryStore = () => {
  const { dispatch, state } = useContext(Context);

  const getDelivery = useCallback(
    async ({ bookId }) => {
      const delivery = await api.get(`/public/deliveries/${bookId}`);

      dispatch({
        type: CONSTANTS.FETCH_BY_ID,
        item: new Delivery(delivery),
      });

      return delivery;
    },
    [dispatch],
  );

  const getCompleted = useCallback(
    async ({ token }) => {
      const delivery = await api.get(
        `/public/deliveries/completed`,
        {},
        {
          "x-auth-token": token,
        },
      );

      dispatch({
        type: CONSTANTS.FETCH_ONE_COMPLETED,
        item: new Delivery(delivery),
      });
    },
    [dispatch],
  );

  const getRiderLocation = useCallback(
    async ({ riderId }) => {
      const { location, riderLocation } = await api.get(
        `/public/riders/${riderId}/location`,
      );

      dispatch({
        type: CONSTANTS.FETCH_RIDER_LOCATION,
        riderLocation: {
          lat: location?.lat || riderLocation?.latitude,
          lng: location?.lng || riderLocation?.longitude,
        },
      });

      return location || riderLocation;
    },
    [dispatch],
  );

  return {
    state,
    getDelivery,
    getCompleted,
    getRiderLocation,
  };
};
